export default __webpack_public_path__ + "static/media/greenSmall.af172ad8.svg";